import React from 'react'
import { type DownloadFile } from '../models/types'
import DownloadTableItem from './DownloadTableItem';
import styles from '../styles/downloads-table.module.css'

import { useTranslation } from 'react-i18next'
import Spinner from '../../common/components/Spinner';

type Props = {
    downloads: DownloadFile[],
    fetching: boolean
}

export default function DownloadTable({downloads=[], fetching=false}: Props) {
    const {t} = useTranslation('downloads');

    if (fetching){
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <Spinner size={100} />
            </div>
        )
    }
    if (!downloads || downloads.length < 1){
        return <h2>{t('noResults')}</h2>
    }
    const tableRows: React.JSX.Element[] = [];
    downloads.forEach((d: DownloadFile) => {
        tableRows.push((
            <DownloadTableItem download={d} />
        ))
    })

  return (
    <table style={{width: '100%'}} className={styles.downloadsTable}>
        <thead>
            <tr>
                <th>{t('family')}</th>
                <th>{t('host')}</th>
                <th>{t('version')}</th>
                <th>{t('os')}</th>
                <th>&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            {tableRows}
        </tbody>
    </table>
  )
}